<template>
  <div class="mt-6 pb-2 w-full ">
    <table class="w-full border border-[#414141] border-collapse table-auto">
      <thead>
        <!-- Table Header -->
        <tr class="bg-[#00423D] text-white font-['Open_Sans'] font-normal border border-[#414141]">
          <th class="font-normal border border-[#414141] border-l-[#00423D] border-t-[#00423D] p-2 text-center">
            Gift Amount
          </th>
          <th class="font-normal border border-[#414141] border-t-[#00423D] p-2">
            # of Gifts Needed
          </th>
          <th class="font-normal border border-[#414141] border-t-[#00423D] p-2">
            # of Prospects Needed
          </th>
          <th class="font-normal border border-[#414141] border-t-[#00423D] p-2">
            Prospect Names
          </th>
          <th class="font-normal border border-[#414141] border-t-[#00423D] p-2">
            Amount By Gift Level
          </th>
          <th class="font-normal border border-[#414141] border-t-[#00423D] p-2">
            Cumulative Gift Amount
          </th>
          <th class="font-normal border border-[#414141] border-r-[#00423D] border-t-[#00423D] p-2">
            Funding Allocation
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Rows -->
        <tr
          class="border border-[#414141] even:bg-[#DDEDEA] odd:bg-white"
          v-for="(row, idx) in tableData"
          :key="idx"
        >
          <td class="border border-[#414141] p-1 w-auto">
            <div class="flex font-['Open_Sans']">
              <input
                type="text"
                placeholder="00.0"
                class="p-1 text-center bg-transparent outline-none border-none w-full min-w-[110px] text-[#00423D] font-['Open_Sans']"
                inputmode="numeric"
                :value="typeof row.giftAmount == 'number' ? formatToDecimal(row.giftAmount) : row.giftAmount"
                readonly
              />
            </div>
          </td>
          <td class="border border-[#414141] p-1">
            <div class="flex font-['Open_Sans']">
              <input
                type="text"
                placeholder="0"
                class="p-1 bg-transparent outline-none border-none w-full text-[#00423D] font-['Open_Sans'] text-center"
                inputmode="numeric"
                :value="row.numberOfGiftsNeeded"
                readonly
              />
            </div>
          </td>
          <td class="border border-[#414141] p-1">
            <div class="flex font-['Open_Sans']">
              <input
                type="text"
                placeholder="0"
                class="p-1 bg-transparent outline-none border-none w-full text-[#00423D] font-['Open_Sans'] text-center"
                inputmode="numeric"
                :value="row.numberOfProspectsNeeded"
                readonly
              />
            </div>
          </td>
          <td class="border border-[#414141] p-1">
            <div class="flex font-['Open_Sans']">
              <input
                class="p-1 bg-transparent outline-none border-none w-full text-[#00423D] font-['Open_Sans'] text-center"
                readonly
              />
            </div>
          </td>
          <td class="border border-[#414141] p-2 text-center text-[#00423D]">
            <div class="flex font-['Open_Sans']">
              <input
                type="text"
                placeholder="00.0"
                class="p-1 bg-transparent text-center outline-none border-none w-full min-w-[65px] text-[#00423D] font-['Open_Sans']"
                inputmode="numeric"
                :value="formatToDecimal(row.amountByGiftLevel)"
                readonly
              />
            </div>
          </td>
          <td class="border border-[#414141] p-2 text-center text-[#00423D]">
            <div class="flex font-['Open_Sans']">
              <input
                type="text"
                placeholder="00.0"
                class="p-1 bg-transparent text-center outline-none border-none w-full min-w-[60px] text-[#00423D] font-['Open_Sans']"
                inputmode="numeric"
                :value="formatToDecimal(row.cumulativeGiftAmount)"
                readonly
              />
            </div>
          </td>
          <td class="border border-[#414141] p-2 text-center text-[#00423D]">
            <div class="flex font-['Open_Sans']">
              <input
                type="text"
                placeholder="00.0"
                class="p-1 text-center bg-transparent outline-none border-none w-full text-[#00423D] font-['Open_Sans']"
                inputmode="numeric"
                :value="row.fundingAllocation + ' %'"
                readonly
              />
            </div>
          </td>
        </tr>
        <!-- Total Row -->
        <tr class="border border-[#414141] bg-white">
          <td class="border border-[#414141] p-2 text-center text-white bg-[#393E46]">
            Grand Total
          </td>
          <td class="border text-center border-[#414141] p-2 text-[#393E46] font-bold">
            {{ calculateTotalGifts() }}
          </td>
          <td class="border text-center border-[#414141] p-2 text-[#393E46] font-bold">
            {{ calculateTotalProspects() }}
          </td>
          <td class="border text-center border-[#414141] p-2 text-[#393E46] font-bold"></td>
          <td class="border text-center border-[#414141] p-2 text-[#393E46] font-bold">
            {{ formatToDecimal(totalFundraisingGoal) }}
          </td>
          <td class="border text-center border-[#414141] p-2 text-[#393E46] font-bold">
            {{ formatToDecimal(totalFundraisingGoal) }}
          </td>
          <td class="border text-center border-[#414141] p-2 text-[#393E46] font-bold">
            100%
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  tableData: {
    type: Array,
    required: true
  },
  totalFundraisingGoal: {
    type: Number,
    required: true
  }
});

const formatToDecimal = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

const calculateTotalGifts = () => {
  return props.tableData.reduce((acc, curr) => {
    if (curr.numberOfGiftsNeeded != "Many") {
      return acc + parseInt(curr.numberOfGiftsNeeded);
    }
    return acc + 0;
  }, 0);
};

const calculateTotalProspects = () => {
  return props.tableData.reduce((acc, curr) => {
    if (curr.numberOfProspectsNeeded != "Many") {
      return acc + parseInt(curr.numberOfProspectsNeeded);
    }
    return acc + 0;
  }, 0);
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>